import {connect} from "react-redux";
import Summary from "./../component/Summary";
import {
    getTotal,
    getSelectedDoctype,
    getSelectedLevel,
    getCurrencySymbol,
    getSelectedVasIds,
    getVases,
    getSelectedVasItems,
    getDiscountValue,
    getDiscountPercent,
} from "./../reducers/index";

const mapStateToProps = state => {
    return {
        total: getTotal(state),
        selectedDoctype: getSelectedDoctype(state),
        selectedLevel: getSelectedLevel(state),
        currencySymbol: getCurrencySymbol(state),
        selectedVasIds: getSelectedVasIds(state),
        vases: getVases(state),
        selectedVasItems: getSelectedVasItems(state),
        discountValue: getDiscountValue(state),
        discountPercent: getDiscountPercent(state),
    }
}

const SummaryContainer = connect(
    mapStateToProps
)(Summary)

export default SummaryContainer
